var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hamburger_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 0.5,
    y: 0.5,
    rx: 28
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.05 38.195c0 1.07.867 1.939 1.938 1.939h31.024a1.939 1.939 0 1 0 0-3.878H12.988c-1.07 0-1.939.868-1.939 1.939Zm0-9.695c0 1.07.867 1.939 1.938 1.939h31.024a1.939 1.939 0 0 0 0-3.878H12.988c-1.07 0-1.939.868-1.939 1.939Zm1.938-11.634a1.939 1.939 0 1 0 0 3.878h31.024a1.939 1.939 0 0 0 0-3.878H12.988Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hamburger_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 28
  })))));
};
export default SvgHamburger;